module.exports = __webpack_public_path__ + "img/video-static.79b03e8a.png";